"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_2 = require("@emotion/react");
function fontFace(fontFamily, fontFace, fontWeight) {
    return {
        "@font-face": {
            fontFamily,
            src: `url("${fontFace.url}") format("${fontFace.format}")`,
            fontWeight,
        }
    };
}
exports.default = ({ fontFamily, bold, medium, normal }) => {
    return (react_1.default.createElement(react_2.Global, { styles: [
            bold && fontFace(fontFamily, bold, 'bold'),
            medium && fontFace(fontFamily, medium, 600),
            normal && fontFace(fontFamily, normal, 'normal'),
        ] }));
};
